import axios, { AxiosRequestConfig } from 'axios';
import { default as config } from '../../../constants/constants';

export interface FlagPayloadType {
  flagId: string;
  documentUrl: string;
  highlightText: string;
}

export const logFlag = async (token: string, data: FlagPayloadType) => {
  const options: AxiosRequestConfig = {
    method: 'POST',
    headers: { 'X-Firebase-Auth': token },
    url: `${config.serverURL}/notes/logs`,
    data
  };

  return axios(options);
};
